import fetch from 'actions/lib/fetch';

export const WEB_RTC_DETECTION = {
  iOS: 'webrtc-detected-ios',
  android: 'webrtc-detected-android',
  failed: 'webrtc-detection-failed',
};

export const WEB_RTC_CAMERA = {
  frontal: 'webrtc-camera-frontal',
  main: 'webrtc-camera-main',
};

export const WEB_RTC_FEATURES = {
  twoWayVideo: 'web-rtc-feature/two-way-video',
  oneWayVideo: 'web-rtc-feature/one-way-video',
  audioOnly: 'web-rtc-feature/audio-only'
};

export const WEB_RTC_FEATURES_MAP = new Map([
  [0, WEB_RTC_FEATURES.audioOnly],
  [1, WEB_RTC_FEATURES.oneWayVideo],
  [2, WEB_RTC_FEATURES.twoWayVideo],
]);

export const WEB_RTC_CAMERAS_MAP = new Map([
  [1, WEB_RTC_CAMERA.main],
  [2, WEB_RTC_CAMERA.frontal],
]);

export const DETECTED = 'chat/web-rtc/detected';
export const NOT_DETECTED = 'chat/web-rtc/not-detected';
export const DETECTION_FAILED = 'chat/web-rtc/detection/failed';
export const DEVICES_GET = 'chat/web-rtc/device/get';
export const DEVICES_GET_FAILED = 'chat/web-rtc/device/get/fail';
const detected = technology => technology !== WEB_RTC_DETECTION.failed
 ? { type: DETECTED, technology } : { type: NOT_DETECTED };
export const detect = (dispatch, detectWebRTCAgentSide, queueID, allowedWebRTCFeatures, customSiteUrlHexEncoded, chatConnectionId) => {
  if (allowedWebRTCFeatures.some(x => x) && (window.location.protocol == "https:") || (window.location.href.substring(0, 17).toLowerCase() == "http://localhost/")) {
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
      //return Promise.resolve(dispatch(detected(WEB_RTC_DETECTION.iOS)));
    } else if (OT && OT.checkSystemRequirements() === 1) {
      return Promise.all([
        new Promise((resolve, reject) => {
          OT.getDevices((error, devices) => resolve(dispatch(error
            ? { type: DEVICES_GET_FAILED, error }
            : { type: DEVICES_GET, devices }
          )));
        }),
        fetch(`chat/encryptchatconnection/${chatConnectionId}`, { method: 'GET', expect: 'text'})
          .then(chatConnectionIdEncrypted => {
            detectWebRTCAgentSide(queueID, 'DESKTOP', customSiteUrlHexEncoded, chatConnectionIdEncrypted,
            allowedWebRTCFeatures.every(f => f === WEB_RTC_FEATURES.audioOnly) ? 1 : 0);
            return dispatch(detected(WEB_RTC_DETECTION.android));
          }).catch(error => dispatch({ type: DETECTION_FAILED, error }))
      ]).then(results => results[1]);
    }
  }

  return Promise.resolve(dispatch(detected(WEB_RTC_DETECTION.failed)));
}

export const AGENT_NOT_SUPPORTED = 'chat/web-rtc-agent/not-supported';
export const AGENT_SUPPORTED = 'chat/web-rtc-agent/supported';
export const agentSupported = supported => ({
  type: supported ? AGENT_SUPPORTED : AGENT_NOT_SUPPORTED
});

export const CHOOSE_CAMERA_START = 'chat/web-rtc/choose-camera/start';
export const CHOOSE_CAMERA_CANCEL = 'chat/web-rtc/choose-camera/cancel';
export const CHOOSE_CAMERA = 'chat/web-rtc/choose-camera';
export const startChooseCamera = () => ({ type: CHOOSE_CAMERA_START });
export const cancelChooseCamera = () => ({ type: CHOOSE_CAMERA_CANCEL });
export const chooseCamera = camera => ({ type: CHOOSE_CAMERA, camera });

export const START = 'chat/web-rtc/start';
export const START_REQUEST = 'chat/web-rtc/start-request';
export const START_FAIL = 'chat/web-rtc/start-fail';
export const start = (startWebRTCInternal, chatConnectionId, mode) => dispatch => {
  startWebRTCInternal();
  dispatch({ type: START_REQUEST, mode });

  return fetch(`webrtc/${chatConnectionId}`, { method: 'GET' })
    .then(webRTCSession => dispatch({ type: START, webRTCSession }))
    .catch(error => dispatch({ type: START_FAIL, error }));
};

export const END = 'chat/web-rtc/end';
export const end = () => ({ type: END });

export const CLIENT_ERROR = 'chat/web-rtc/client-error';
export const clientError = error => ({ type: CLIENT_ERROR, error });



// WEBPACK FOOTER //
// ./actions/chat/webrtc.js